
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/dealership-enquiry",
      function () {
        return require("private-next-pages/india/dealership-enquiry.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/dealership-enquiry"])
      });
    }
  